import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import StepsProgressBar from './StepsProgressBar';
import messages from '../forgot-password-code/messages';

const ResetPasswordStepsTabs = ({ step }) => {
  const { formatMessage } = useIntl();

  const steps = [
    {
      id: 1,
      tabTitle: formatMessage(messages['reset.password.tabs.point.verify.email']),
    },
    {
      id: 2,
      tabTitle: formatMessage(messages['reset.password.tabs.point.change.password']),
    },
  ];

  return (
    <StepsProgressBar
      activeStep={step}
      steps={steps}
      linesWidth={150}
    />
  );
};

ResetPasswordStepsTabs.propTypes = {
  step: PropTypes.number.isRequired,
};

export default ResetPasswordStepsTabs;
